<template>
<div class="chapter">
<div class="inner_page">
<div id="fm4">
<p class="title"><span>U P</span></p>
<p class="title1"><span>T H R O U G H</span></p>
<p class="title2"><span>T H E  W A T E R</span></p>
<p class="title3"><span>DARCEY STEINKE</span></p>
<p class="fimage1">
<img alt="image_0001" class="imgepub" src="images/image_0001.jpg"/></p>
<p class="title4"><span>G R O V E  P R E S S</span></p>
<p class="title5"><span>N E W  Y O R K</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?61601403